import React from "react";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { Typography } from "@mui/material";
import { useTheme } from "@emotion/react";

function CircularProgressComponents({
  superValue,
  subValue,
  start,
  end,
  currentValue,
}) {
  const value = ((currentValue - start) / (end - start)) * 100;

  const theme = useTheme();
  return (
    <CircularProgressbarWithChildren
      value={value}
      strokeWidth={5}
      styles={buildStyles({
        strokeLinecap: "butt",
        trailColor: "#FFD06233",
        pathColor: theme.palette.button.main,
        rotation: 0.5,
        path: {
          strokeDasharray: "0 1",
        },
        height: "30px",
      })}
    >
      <Typography
        style={{
          color: theme.palette.button.main,
          height: "20%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontFamily: "IRAN",
          fontSize: "0.7rem",
        }}
      >
        {superValue || " "}
      </Typography>
      <Typography
        style={{
          color: theme.palette.button.main,
          width: "90%",
          height: "40%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontFamily: "IRAN",
          fontSize: "2.2rem",
        }}
      >
        {currentValue}
      </Typography>
        <Typography
          style={{
            color: theme.palette.button.main,
            fontFamily: "IRAN",
            height: "15%",
            fontSize: "0.7rem",
          }}
        >
          {subValue || " "}
        </Typography>
    </CircularProgressbarWithChildren>
  );
}

export default CircularProgressComponents;
